import script from "./QuestionSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestionSlider.vue?vue&type=script&setup=true&lang=js"

import "./QuestionSlider.vue?vue&type=style&index=0&id=b2df3874&scoped=true&lang=scss"

import exportComponent from "/Users/ben/Local Sites/serenialife-public/app/public/wp-content/themes/serenialife-public-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b2df3874"]])

export default __exports__